import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { fetchClientPurchasedItems } from "../../../../lib/api";
import { dateMonthsAgo, type ClientProfileTab } from "../page/pageHelpers";

export function usePurchaseBehaviorQuery({
    activeTab,
    profileId,
    enabled = true,
}: {
    activeTab: ClientProfileTab;
    profileId: string;
    enabled?: boolean;
}) {
    const dateFrom = useMemo(() => dateMonthsAgo(12), []);

    return useQuery({
        queryKey: ["client-360-purchase-behavior", profileId, dateFrom],
        queryFn: () => fetchClientPurchasedItems({
            profileId,
            dateFrom,
            page: 1,
            perPage: 100,
            sortDirection: "desc",
        }),
        enabled: enabled && profileId !== "" && activeTab === "purchase-behavior",
        retry: 1,
        staleTime: 60_000,
    });
}
